// The client platform's dark mode inverts Aura's whole iframe with a CSS filter, which Aura
// can't see from inside. Our own colours survive that (everything has a border), but photos
// come out as negatives. When the platform says it is inverting, photos get the same filter
// again: inverting twice gives the real colours back. Nothing else changes.
//
// The platform can say so in any of these ways (the value is the filter it applies):
//   - iframe URL:        ?color_inversion=hue | plain
//   - CLIENT_DATA:       { type: 'CLIENT_DATA', ..., colorInversion: 'hue' | 'plain' | 'off' }
//   - when it changes:   { type: 'AURA_COLOR_INVERSION', colorInversion: 'hue' | 'plain' | 'off' }
// 'hue' = invert(1) hue-rotate(180deg) (browser auto-dark, Dark Reader); 'plain' = invert(1).
// Until it says so, photos are shown as they are.

const FILTERS = {
  hue: 'invert(1) hue-rotate(180deg)',
  plain: 'invert(1)',
};

// Photos use this as their CSS filter
export const PHOTO_FILTER = 'var(--aura-photo-filter, none)';

export const applyColorInversion = (mode) => {
  const filter = FILTERS[mode] || 'none';
  document.documentElement.style.setProperty('--aura-photo-filter', filter);
  document.documentElement.dataset.colorInversion = FILTERS[mode] ? mode : 'off';
};

const modeFrom = (data) => {
  if (!data || typeof data !== 'object') return undefined;
  if (data.type === 'AURA_COLOR_INVERSION' || (data.type === 'CLIENT_DATA' && 'colorInversion' in data)) {
    return data.colorInversion;
  }
  return undefined;
};

export const initColorInversion = () => {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('color_inversion');
    if (fromUrl) applyColorInversion(fromUrl);
  } catch (e) { /* no URL params */ }

  window.addEventListener('message', (event) => {
    // Only the page Aura is embedded in decides this
    if (window.parent === window || event.source !== window.parent) return;
    let data = event.data;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch (e) { return; }
    }
    const mode = modeFrom(data);
    if (mode !== undefined) applyColorInversion(mode);
  });
};
